<template>
	<div class="main--content" id="PageMycshare">
		<div class="wrapper-fluid bg-picture-darken small-nav">

			<Navigation />

			<div class="container content-mycshare" :class="{'getblurred': isModalVisible}">

				<div class="row">
					<div class="col-12">
						<div class="wrapper-headlines">
							<div class="row justify-content-center">
								<div class="col-md-12 col-lg-auto">
									<h1 class="d-inline-block">&nbsp;</h1>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="row">
					<div class="col-md-5 col-lg-4 wrapper-rounded-content">
						<div class="bg-blue-multiply rounded-corners mr15"></div>

						<div class="row justify-content-center headinline mr15">
							<div class="col-md-12 p-0">
								<h1 class="d-inline-block">{{ $t('My C-Share') }}</h1>
								<ul>
									<li class="navi-my-element"	v-bind:class="{ active: (page === 'bookings') }">
										<router-link :to="{name: 'PageMybookings'}">
											<i class="icn icn-sidenav icn-sheets"></i>
											<div class="sidenav-text">{{ $t('Reservation') }}</div>
										</router-link>
									</li>
									<li class="navi-my-element" v-bind:class="{ active: (page === 'mydata') }">
										<router-link :to="{name: 'PageMydata'}">
											<i class="icn icn-sidenav icn-adjust"></i>
											<div class="sidenav-text">Meine Daten</div>
										</router-link>
									</li>
									<li v-if="$store.getters['orm/param']('BCSAPP_NO_PAYMENT').value ==='0' && $store.getters['orm/param']('BCSAPP_USE_CONCARDIS').value ==='1'" class="navi-my-element" v-bind:class="{ active: (page === 'payment') }">
										<router-link :to="{name: 'PageMyPayment'}">
											<i class="icn icn-sidenav icn-adjust"></i>
											<div class="sidenav-text">Meine Zahlungsart</div>
										</router-link>
									</li>
									<li class="navi-my-element">
										<a href="#" @click="processLogout">
											<i class="icn icn-sidenav icn-key"></i>
											<div class="sidenav-text">Abmelden</div>
										</a>
									</li>
								</ul>
							</div>
						</div>
					</div>

					<router-view @isActive="setActive" />

				</div>

			</div>

			<modal v-show="isModalVisible" @clicked="closeModal" :isModalVisible="isModalVisible"	:largeModal="true" :twoButtons="true">
			<h3 slot="headline">{{ $t('Wollen Sie sich wirklich von C-Share abmelden?') }}</h3>
			<p slot="text">{{ $t('') }}</p>
			<template slot="firstBtn">{{ $t('Ja') }}</template>
			<template slot="closeBtn">{{ $t('Nein') }}</template>

			</modal>
			<div v-show="isModalVisible" @click="closeModal" class="modal-backdrop show"></div>

			<Footer></Footer>

		</div>
	</div>
</template>

<script>
import find from 'lodash/find';
import { mapGetters } from 'vuex'
export default {
	name: 'PageMycshare',
	data() {
		return{
			isModalVisible: false,
			page: ''
		}

	},
	methods: {
		setActive(msg) {
			this.page = msg;
		},
		showModal() {
			this.isModalVisible = true;
			document.body.classList.add("modal-open");
      	},
      	closeModal(value) {
      		switch (value) {
			  case 'close':
			  	break;
			  case 'submit':
			  	this.processLogout(ev);
			  	break;
			  default:

			}
        	this.isModalVisible = false;
        	document.body.classList.remove("modal-open");
      	},
      	processLogout() {
	        var self = this;
	        this.$store.dispatch('orm/LOGOUT_CUSTOMER')
	        .then(res => {
	          self.showMenu = !self.showMenu
	          self.$router.push({ path: '/' })
	        });

	      }
	}
}
</script>





// WEBPACK FOOTER //
// src/components/Pages/PageMycshare.vue